import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import downloadReport from '@worklist-2/patientPortal/src/utils/downloadReport';

import { useAuth } from '@rs-core/context/UserAuthContext';
import PdfViewer from '@rs-ui/components/PdfViewer';
import downloadIcon from '@worklist-2/ui/src/assets/img/homepage/download.svg';

import usePreventTouch from '../../../hooks/usePreventTouch';

const MobileReportDetail = ({ report, onGoBack }) => {
	const [isDownloading, setIsDownloading] = useState(false);

	const { t } = useTranslation('homepage');
	const __userAuthContext = useAuth();

	usePreventTouch();

	const handleDownload = useCallback(async () => {
		try {
			if (!report) return null;

			setIsDownloading(true);

			await downloadReport(report.reportPath, report.reportName);

			setIsDownloading(false);
		} catch (err) {
			setIsDownloading(false);
		}
	}, [report]);

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<IconButton
					data-testid="back-button"
					sx={{ background: '#F3F3F3', boxShadow: '2px 3px 7px rgba(18, 18, 18, 0.15)', marginRight: '17px' }}
					onClick={onGoBack}
				>
					<Icon component={KeyboardArrowLeftIcon} sx={{ color: 'rgba(0, 0, 0, 0.87)' }} />
				</IconButton>

				<Typography noWrap sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.6)', marginRight: '24px' }}>
					{report.reportName}
				</Typography>
				<Button
					data-testid="download-button"
					disabled={isDownloading}
					startIcon={
						<Icon
							component={downloadIcon}
							sx={{
								height: '20px',

								path: {
									stroke: isDownloading ? 'rgba(0, 0, 0, 0.26)' : '',
								},
							}}
						/>
					}
					sx={{
						color: 'rsPrimary.main',
						fontSize: '14px',
						textTransform: 'none',
						fontWeight: 600,
						lineHeight: '20px',
						height: '20px',
						width: '91px',
						margin: '0 10px',
					}}
					onClick={handleDownload}
				>
					{t('Download')}
				</Button>
			</Box>

			<Divider sx={{ margin: '16px -16px' }} />

			<Box
				sx={{ '& .rpv-core__inner-page': { boxSizing: 'border-box', touchAction: 'pan-x pan-y pinch-zoom' } }}
				onTouchMove={e => {
					e.stopPropagation();
				}}
				onWheel={e => {
					e.stopPropagation();
				}}
			>
				<PdfViewer
					isBlume
					showToolbar
					blumeToolbarSx={{ position: 'fixed', left: '50%', transform: 'translateX(-50%)' }}
					canvasHeight="80vh"
					defaultZoomLevel={1}
					fileUrl={report.reportPath}
					headers={{
						Accept: '*/*',
						Authorization: __userAuthContext.accessToken,
						SessionID: __userAuthContext.sessionId,
					}}
					isLoading={false}
				/>
			</Box>
		</Box>
	);
};

export default MobileReportDetail;
